/* eslint-disable linebreak-style */
/*
 * @Date: 2022-02-09 13:24:20
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-12 10:30:58
 * @FilePath: \mobile-portal\src\router\router.js
 */
import Vue from 'vue';
import Router from 'vue-router';
import { kebabCase } from 'lodash';
import { getRequestParam, getCookieByKey, getUrlData } from './../utils/auth.js';
import auth from '../utils/index';
import '../global/i18n/index';
import { axios } from '@/global';
import { AutoLogin,loginByWX ,getUrlName,deUrlParam} from '@/utils/autoLogin';
import store from '@/store';
import { Toast } from 'vant';

const lang = getCookieByKey('lang');
let pageTitle = null;
if (lang === 'en') {
  pageTitle = {
    home: 'Home',
    workbench: 'Workbench',
    login:'Login',
  };
} else {
  pageTitle = {
    home: '首页',
    workbench: '工作台',
    login:'登陆'
  };
}
const routes = [{ path: '/', redirect: '/home' }]; // 指定首页

const views = require.context('@/views', true, /\.vue$/, 'lazy');
views.keys().reduce((res, key) => {
  const name = kebabCase((key.split('.'))[1]);

  // 详情页更改为动态路由匹配，例如: user-detail => user/:id/detail
  // 所以详情页面命名约定为XXXDetail
  let path = name;
  if (name.indexOf('detail') !== -1) {
    const arrs = name.split('-');
    arrs.splice(1, 0, ':id');
    path = arrs.join('/');
  }
  res.push({
    name,
    path: `/${path}`,
    component: () => views(key),
    meta: { title: pageTitle[name] },
  });
  return res;
}, routes);
Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path === '/login') {
    next();
  } else {
    const token = localStorage.getItem('PAI-token');
    if (token ) {
      //从登陆页到hone 不需要再校验code，有token就可以
      if(to.path === '/home' && from.path ==='/'){
        const isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 判断移动端类型
        const isWeCom= /wxwork/i.test(navigator.userAgent); // 判断是否为企业微信类
        if((isWeCom && isMobile)||(isWeCom && !isMobile)){
          const parmas = getRequestParam(location.href);
          const localCode=auth.getStorageByKey('PAI-code');
          if (parmas && parmas.code) {
            if(parmas.code !== localCode){
            Toast.loading();
            axios({
              url:'/WeChatLnterfaceBusiness/GetMobileLogin?WeChatUserName='+parmas.code,
              method: 'post',
              headers: {},
              data:{
                  WeChatUserName:parmas.code,
                  EnterpriseMicroenterpriseName:''
                }
              }).then((res) => {
                Toast.clear();
                if(res.code==200){
                  store.dispatch('RequestToken',res.data.UserName).then((response)=>{
                    localStorage.setItem('PAI-token', JSON.stringify(response.data))
                    localStorage.setItem('Login-time', new Date().getTime());
                    localStorage.setItem('PAI-account', JSON.stringify(res.data))
                    localStorage.setItem('PAI-code', parmas.code)
                    next();
                  }).catch((err)=>{
                    Toast.clear();
                  })
                }else{
                  Toast.clear();
                  next('/login')
                }
              }).catch(error => {
                Toast.clear();
                next('/login')
              });
          } else {
            next();
          }
        }else{
          next();
        }
        }else{
          next();
        }
      }else{
        next()
      }
    }else{
    // } else {
    //   //临时使用：解决退出后URL内容不满足条件时，直接跳转登录页
    //   next('/login');
    // }
    // else if (getUrlData('wwid')) {
    //   AutoLogin((result) => {
    //     next();
    //   }, (err) => {
    //     next();
    //   });
    //    // 微信授权
    // }
    if (window.AUTH_MODE === 'wx') {
        const parmas = getRequestParam(location.href);
        if (parmas && parmas.code) {
          Toast.loading();
          axios({
            url:'/WeChatLnterfaceBusiness/GetMobileLogin?WeChatUserName='+parmas.code,
            method: 'post',
            headers: {},
            data:{
                WeChatUserName:parmas.code,
                EnterpriseMicroenterpriseName:''
              }
            }).then((res) => {
              Toast.clear();
              if(res.code==200){
                store.dispatch('RequestToken',res.data.UserName).then((response)=>{
                  localStorage.setItem('PAI-token', JSON.stringify(response.data))
                  localStorage.setItem('Login-time', new Date().getTime());
                  localStorage.setItem('PAI-account', JSON.stringify(res.data))
                  localStorage.setItem('PAI-code', parmas.code)
                  next('/home');
                }).catch((err)=>{
                  Toast.clear();
                })
              }else{
                Toast.clear();
                next('/login')
              }
          }).catch(error => {
            Toast.clear();
            next('/login')
          });
        } else {
          next('/login');
        }
    } 
    else{
      next('/login');
    }
  }
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});


export default router;
